import { createSetData } from '../../../shared/utils/createSetData';
import store from './store';

const setData = createSetData(store);

export * from './events';
export { store, setData };
